import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { VacanciesComponent } from './content/vacancies/vacancies.component';
import { PaperworkComponent } from './content/paperwork/paperwork.component';
import { WarrantiesComponent } from './content/warranties/warranties.component';
import { AboutComponent } from './content/about/about.component';
import { PressComponent } from './content/press/press.component';

const appRoutes: Routes = [
  {path: '', redirectTo: 'vacancies', pathMatch: 'full'},
  {path: 'vacancies', component: VacanciesComponent },
  {path: 'paperwork', component: PaperworkComponent},
  {path: 'warranties', component: WarrantiesComponent },
  {path: 'abuot', component: AboutComponent },
  {path: 'press', component: PressComponent },

  ];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes)
  ],
 exports: [
  RouterModule
 ]
})
export class AppRoutingModule { }
